import light from "./light"
import dark from "./dark"


export type ColorModeType = 'dark' | 'light' | 'system'


export type ColorModeConfig = Record<string, any>

export interface ThemeConfig {
  light: ColorModeConfig,
  dark: ColorModeConfig,
  initColorMode: ColorModeType,
}

export interface UserThemeConfig {
  light?: ColorModeConfig,
  dark?: ColorModeConfig,
  initColorMode?: ColorModeType,
}

export const defaultConfig: ThemeConfig = {
  light,
  dark,
  initColorMode: 'light',
}
